import { render, staticRenderFns } from "./CallCentreDesignData.vue?vue&type=template&id=a11203d0&scoped=true"
import script from "./CallCentreDesignData.vue?vue&type=script&lang=ts"
export * from "./CallCentreDesignData.vue?vue&type=script&lang=ts"
import style0 from "./CallCentreDesignData.vue?vue&type=style&index=0&id=a11203d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11203d0",
  null
  
)

export default component.exports